import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

type EntityType = 'tool' | 'resource' | 'job_board';

export function useCommentCount(entityType: EntityType, entityId: string) {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCommentCount = async () => {
      if (!entityId || !entityType) {
        setCount(0);
        setLoading(false);
        return;
      }

      try {
        const { count: commentCount, error } = await supabase
          .from('comments')
          .select('*', { count: 'exact', head: true })
          .eq('entity_type', entityType)
          .eq('entity_id', entityId)
          .eq('is_deleted', false);

        if (error) {
          console.error('Error fetching comment count:', error);
          setCount(0);
        } else {
          setCount(commentCount || 0);
        }
      } catch (error) {
        console.error('Error fetching comment count:', error);
        setCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchCommentCount();
  }, [entityType, entityId]);

  return { count, loading };
}